import { createFileRoute, Outlet } from '@tanstack/react-router'
import Media from '../../../../../containers/Media'
import { mediaContextSearchSchema } from './search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/media'
)({
  validateSearch: mediaContextSearchSchema,
  component: ProjectMediaWrapper
})

function ProjectMediaWrapper() {
  return (
    <>
      <Media />
      <Outlet />
    </>
  )
}
